(function () {
    'use strict';

    angular
        .module('virtualFairs')
        .controller('PhysicalFairStudentsEnrolledController', PhysicalFairStudentsEnrolledController);
        PhysicalFairStudentsEnrolledController.$inject = ['$scope','ExpoService', 'VirtualFairService', 'PhysicalFairService', 'CitiesByExpoService','$timeout'];
    function PhysicalFairStudentsEnrolledController($scope, ExpoService, VirtualFairService, PhysicalFairService, CitiesByExpoService, $timeout) {
        var vm = this;

        vm.getAllExpos          = getAllExpos;
        vm.getWhoPays           = getWhoPays;
        vm.getHowMuch           = getHowMuch;
        vm.getCountries         = getCountries;
        vm.getByFilter          = getByFilter;
        vm.clearForm            = clearForm;
        vm.invite               = invite;
        vm.checkAll             = checkAll;
        vm.downloadCsv          = downloadCsv;
        vm.selectCitiesByExpo   = selectCitiesByExpo;
        vm.checkCity            = checkCity;
        vm.activate             = activate;
        vm.getPrograms          = getPrograms;
        
        
        vm.datePickerOptions = {
            format: "D-MMM-YY",
            fromLabel: "From",
            toLabel: "To"
        };

        vm.expoSelected             = [];
        vm.citySelected             = [];
        vm.studentName              = '';
        vm.studentEmail             = '';
        vm.openedTickets            = [{id : -1, name: '--- All ---'},{id : 0, name : 'No'},{id : 1, name : 'Yes'}];
        vm.openedTicketsSelected    = -1;
        vm.studiedAbroad            = [{id : -1, name: '--- All ---'},{id : 0, name : 'No'},{id : 1, name : 'Yes'}];
        vm.studiedAbroadSelected    = -1;
        vm.confirmed                = [{id : -1, name: '--- All ---'},{id : 0, name : 'No'},{id : 1, name : 'Yes'}];
        vm.isParent                 = [{id : -1, name: '--- All ---'},{id : 0, name : 'No'},{id : 1, name : 'Yes'}];
        vm.isParentSelected         = -1;
        vm.isParent                 = [{id : -1, name: '--- All ---'},{id : 0, name : 'No'},{id : 1, name : 'Yes'}];
        vm.workWhileSelected        = -1;
        vm.workWhile                = [{id : -1, name: '--- All ---'},{id : 0, name : 'No'},{id : 1, name : 'Yes'}];
        vm.programSelected          = [];
        vm.budget                   = [0, 10000];
        vm.programs                 = [];
        

        vm.confirmedSelected        = -1;
        vm.whoPaysSelected          = [];
        vm.registrationDate         = {startDate: null, endDate: null};
        vm.howMuchSelected          = [];
        vm.countrySelected          = [];
        vm.countryFilter            = [{id : 1, name : 'All from'}, {id : 0, name : 'All but'}];
        vm.countryFilterSelected    = 1;
        vm.studentsSelected         = {};
        vm.flag                     = false;
        vm.allChecked               = false;

        vm.datePickerOptions = {
            format: "D-MMM-YY",
            fromLabel: "From",
            toLabel: "To"
        };

        function getAllExpos () {
            ExpoService.getExpos().then(function(response) {
                vm.expos = response.data;
            }).catch(function(err) {
            });
        }

        function selectCitiesByExpo () {
            vm.query = {};
            vm.query['expos_ids']  = JSON.stringify(vm.expoSelected);
            CitiesByExpoService.getCitiesByExposIds(vm.query).then(function(response){
                vm.cities = response.data;
            }).catch(function(err) {

            });
        }

        function checkCity() {
            vm.citySelected = [];
            vm.selectCitiesByExpo();
        }

        function getWhoPays () {
            VirtualFairService.whoPays().then(function(response) {
                vm.whoPays = response.data;
            }).catch(function(err) {
            });
        }

        function getHowMuch () {
            VirtualFairService.howMuch().then(function(response) {
                vm.howMuch = response.data;
            }).catch(function(err) {
            });
        }

        function getCountries () {
            VirtualFairService.countries().then(function(response) {
                vm.countries = response.data;
            }).catch(function(err) {
            });
        }

        function getPrograms () {
            PhysicalFairService.getPrograms().then(function(response) {
                vm.programs = response.data;
            }).catch(function(err) {
            });
        }

        function clearForm () {
            vm.expoSelected             = [];
            vm.citySelected             = [];
            vm.studentName              = '';
            vm.openedTickets            = -1;
            vm.studiedAbroadSelected    = -1;
            vm.isParentSelected         = -1;
            vm.confirmedSelected        = -1;
            vm.whoPaysSelected          = [];
            vm.programSelected          = [];
            vm.howMuchSelected          = [];
            vm.countryFilterSelected    = 1;
            vm.countrySelected          = [];
            vm.registrationDate         = {startDate: null, endDate: null};
            vm.studentsSelected         = {};
        }

        function getByFilter () {
            vm.flag = false;
            let query = {};
            query['expos'] = JSON.stringify(vm.expoSelected);
            query['cities'] = JSON.stringify(vm.citySelected);
            query['studentName'] = vm.studentName;
            query['studentEmail'] = vm.studentEmail;
            if (vm.confirmedSelected != -1) {
                query['confirmed'] = vm.confirmedSelected;
            }
            if (vm.programSelected.length > 0) {
                query['program'] = vm.programSelected;
            }            
            if (vm.whoPaysSelected.length > 0) {
                query['whoPays'] = JSON.stringify(vm.whoPaysSelected);
            }
            if (vm.workWhileSelected != -1){
                query['workWhileStudy'] = JSON.stringify(vm.workWhileSelected);
            }
            query['countryFilter'] = vm.countryFilterSelected;
            query['countrySelected'] = JSON.stringify(vm.countrySelected);
            query['openedTickets'] = vm.openedTicketsSelected;
            if(vm.registrationDate.startDate !== null && vm.registrationDate.endDate !== null) {
                query['registrationDateStart'] = moment(vm.registrationDate.startDate).format('YYYY-MM-DD 00:00:00');
                query['registrationDateEnd'] = moment(vm.registrationDate.endDate).format('YYYY-MM-DD 23:59:59');
            }
            query['page'] = vm.page;
            PhysicalFairService.getStudentsEnrolled(query).then(function(response) {
                vm.flag = true;
                vm.studentsEnrolled = response.data;
            }).catch(function(err) {
            });
        }


        function downloadCsv () {
            let query = {};
            query['expos'] = JSON.stringify(vm.expoSelected);
            query['cities'] = JSON.stringify(vm.citySelected);
            query['studentName'] = vm.studentName;
            query['studentEmail'] = vm.studentEmail;
            if (vm.confirmedSelected != -1) {
                query['confirmed'] = vm.confirmedSelected;
            }
            if (vm.programSelected.length > 0) {
                query['program'] = vm.programSelected;
            }
            if (vm.budget.length > 0) {
                query['budgetMin'] = vm.budget[0];
                query['budgetMax'] = vm.budget[1];
            }
            if (vm.workWhileSelected != -1){
                query['workWhileStudy'] = JSON.stringify(vm.workWhileSelected);
            }
            query['countryFilter'] = vm.countryFilterSelected;
            query['countrySelected'] = JSON.stringify(vm.countrySelected);
            query['openedTickets'] = vm.openedTicketsSelected;
            if(vm.registrationDate.startDate !== null && vm.registrationDate.endDate !== null) {
                query['registrationDateStart'] = moment(vm.registrationDate.startDate).format('YYYY-MM-DD 00:00:00');
                query['registrationDateEnd'] = moment(vm.registrationDate.endDate).format('YYYY-MM-DD 23:59:59');
            }
            query['page'] = vm.page;
            PhysicalFairService.getStudentsEnrolledCsv(query).then(function(response) {
                var anchor = document.createElement('a');
                anchor.href = 'data:attachment/csv;charset=utf-8,' + encodeURI(response.data);
                anchor.target = '_blank';
                anchor.download = 'report_physical_fairs_students_enrolled.csv';
                document.body.appendChild(anchor);
                anchor.click();
                $timeout(function () {
                    anchor.remove();
                }, 50);
            }).catch(function(err) {
            });
        }

        function invite () {
            let query = {};
            query['students'] = vm.studentsSelected;
            PhysicalFairService.sendInviteToStudentsEnrolled(query).then(function(response) {
                alertify.notify('Invitations successfully sended!', 'success', 3);
                vm.getByFilter();
                vm.allChecked = false;
                //vm.checkAll();
            }).catch(function(err) {
            });
        }

        function checkAll () {
            angular.forEach(vm.studentsEnrolled, function(student){ 
                vm.studentsSelected[student.id] = vm.allChecked;
            });
        }

        function activate () {
            vm.getAllExpos();
            vm.getWhoPays();
            vm.getPrograms();
            vm.getHowMuch();
            vm.getCountries();
        }

        vm.activate();
    }
})();